"use client";

import { CompleteSentenceBlock } from "@/lib/utils/lomdaV3/types";
import { WidthControl } from "./blockAppearance";

/** Topbar for the complete-the-sentence block. Editing (sentence + answer) is
 *  inline on the block, so the topbar only carries the shared width control. */
export default function CompleteSentenceSettings({
    block,
}: {
    block: CompleteSentenceBlock;
}) {
    return (
        <div className="flex items-center gap-3">
            <WidthControl blockId={block.id} />
        </div>
    );
}
